import { render, staticRenderFns } from "./HomeP.vue?vue&type=template&id=97eca304&scoped=true&"
import script from "./HomeP.vue?vue&type=script&lang=js&"
export * from "./HomeP.vue?vue&type=script&lang=js&"
import style0 from "./HomeP.vue?vue&type=style&index=0&id=97eca304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97eca304",
  null
  
)

export default component.exports